import {Injectable} from '@angular/core';
import {RegisterDataTableService} from '../../../core/services/register-data-table.service';
import {StorageService} from '../../../core/services/storage.service';
import {ITableColumn} from '../../../core/common/interfaces/table-column.interface';


@Injectable({
  providedIn: 'root'
})
export class LandmarkTableService extends RegisterDataTableService {


  constructor(
    storageService: StorageService
  ) {
    super(storageService);
  }


  override getColumns(): ITableColumn[] {
    return [
      {
        name: 'id',
        title: 'Id',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'criterionName',
        title: 'Критерий',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'period',
        title: 'Тип оценки',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'name',
        title: 'Целевой ориентир',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'shortName',
        title: 'Условное обозначение',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'weight',
        title: 'Вес целевого ориентира',
        default: true,
        useCustomTemplate: false,
        maxWidth: '100px'
      },
      {
        name: 'status',
        title: 'Архив',
        useCustomTemplate: true,
        default: true,
      },
    ];
  }


}
